import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
// Core Pages
import { Home } from './pages/Home';
import { FreeTrial } from './pages/FreeTrial';
import { ThankYou } from './pages/ThankYou';
import { Programs } from './pages/Programs';
import { MiniTroopers } from './pages/MiniTroopers';
import { AdultTaekwondo } from './pages/AdultTaekwondo';
import { FamilyClasses } from './pages/FamilyClasses';
import { SelfDefense } from './pages/SelfDefense';
import { CompetitionTeam } from './pages/CompetitionTeam';
import { About } from './pages/About';
import { Reviews } from './pages/Reviews';
import { Schedule } from './pages/Schedule';
import { Contact } from './pages/Contact';
// Landing Pages
import { KidsTaekwondo } from './pages/landing/KidsTaekwondo';
import { KidsMartialArts } from './pages/landing/KidsMartialArts';
import { KidsKarate } from './pages/landing/KidsKarate';
import { AfterSchool } from './pages/landing/AfterSchool';
import { TaekwondoNearMe } from './pages/landing/TaekwondoNearMe';
import { MartialArtsNearMe } from './pages/landing/MartialArtsNearMe';
// Location Pages
import { FarmingtonHills } from './pages/locations/FarmingtonHills';
import { Novi } from './pages/locations/Novi';
import { Commerce } from './pages/locations/Commerce';
import { Livonia } from './pages/locations/Livonia';
import { Farmington } from './pages/locations/Farmington';
import { Waterford } from './pages/locations/Waterford';
import { Northville } from './pages/locations/Northville';
// Meta Ads Landing Page
import { StartFree } from './pages/StartFree';
// Summer Camp
import { SummerCamp } from './pages/SummerCamp';
export default function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="free-trial" element={<FreeTrial data-id="element-7" />} data-id="element-6" />
          <Route path="thank-you-free-trial" element={<ThankYou data-id="element-9" />} data-id="element-8" />

          {/* Core Interior Pages */}
          <Route path="programs" element={<Programs data-id="element-11" />} data-id="element-10" />
          <Route path="mini-troopers" element={<MiniTroopers data-id="element-13" />} data-id="element-12" />
          <Route path="adult-taekwondo-classes" element={<AdultTaekwondo data-id="element-15" />} data-id="element-14" />
          <Route path="family-martial-arts-classes" element={<FamilyClasses data-id="element-17" />} data-id="element-16" />
          <Route path="self-defense-classes" element={<SelfDefense data-id="element-19" />} data-id="element-18" />
          <Route path="competition-team" element={<CompetitionTeam data-id="element-21" />} data-id="element-20" />
          <Route path="coaches" element={<About data-id="element-23" />} data-id="element-22" />
          <Route path="reviews" element={<Reviews data-id="element-25" />} data-id="element-24" />
          <Route path="schedule" element={<Schedule data-id="element-27" />} data-id="element-26" />
          <Route path="contact" element={<Contact data-id="element-29" />} data-id="element-28" />

          {/* Google Ads Landing Pages */}
          <Route path="kids-taekwondo-classes" element={<KidsTaekwondo data-id="element-31" />} data-id="element-30" />
          <Route path="kids-martial-arts-classes" element={<KidsMartialArts data-id="element-33" />} data-id="element-32" />
          <Route path="kids-karate-classes" element={<KidsKarate data-id="element-35" />} data-id="element-34" />
          <Route path="after-school-activities" element={<AfterSchool data-id="element-37" />} data-id="element-36" />
          <Route path="taekwondo-near-me" element={<TaekwondoNearMe data-id="element-39" />} data-id="element-38" />
          <Route path="martial-arts-near-me" element={<MartialArtsNearMe data-id="element-41" />} data-id="element-40" />

          {/* Location Pages */}
          <Route path="farmington-hills-martial-arts" element={<FarmingtonHills data-id="element-43" />} data-id="element-42" />
          <Route path="novi-martial-arts" element={<Novi data-id="element-45" />} data-id="element-44" />
          <Route path="commerce-martial-arts" element={<Commerce data-id="element-47" />} data-id="element-46" />
          <Route path="livonia-martial-arts" element={<Livonia data-id="element-49" />} data-id="element-48" />
          <Route path="farmington-martial-arts" element={<Farmington data-id="element-51" />} data-id="element-50" />
          <Route path="waterford-martial-arts" element={<Waterford data-id="element-53" />} data-id="element-52" />
          <Route path="northville-martial-arts" element={<Northville data-id="element-55" />} data-id="element-54" />

          {/* Meta Ads Landing Page */}
          <Route path="start-free" element={<StartFree data-id="element-57" />} data-id="element-56" />

          {/* Summer Camp */}
          <Route path="summer-camp" element={<SummerCamp data-id="element-59" />} data-id="element-58" />

          {/* Catch-all */}
          <Route path="*" element={<Home data-id="element-61" />} data-id="element-60" />
        </Route>
      </Routes>
    </BrowserRouter>;
}